import fetchApi from './api';
import {ApiResponse, LoginResponse, SearchPaging} from 'models/model';
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

export const SettingSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Setting/Save', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const SettingGet = async (key: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Setting/Get', {
        method: 'POST',
        body: JSON.stringify({ key })
    });
};

export const SettingGetAll = async (): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Setting/GetAll', {
        method: 'POST',
    });
};

export const SettingDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Setting/Delete', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

